import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.sort.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './bracketMatching.css';
import * as nls from '../../../nls.js';
import { RunOnceScheduler } from '../../../base/common/async.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { EditorAction, registerEditorAction, registerEditorContribution } from '../../browser/editorExtensions.js';
import { Position } from '../../common/core/position.js';
import { Range } from '../../common/core/range.js';
import { Selection } from '../../common/core/selection.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';
import { OverviewRulerLane } from '../../common/model.js';
import { ModelDecorationOptions } from '../../common/model/textModel.js';
import { editorBracketMatchBackground, editorBracketMatchBorder } from '../../common/view/editorColorRegistry.js';
import { registerColor } from '../../../platform/theme/common/colorRegistry.js';
import { registerThemingParticipant, themeColorFromId } from '../../../platform/theme/common/themeService.js';
import { MenuRegistry, MenuId } from '../../../platform/actions/common/actions.js';
var overviewRulerBracketMatchForeground = registerColor('editorOverviewRuler.bracketMatchForeground', {
  dark: '#A0A0A0',
  light: '#A0A0A0',
  hc: '#A0A0A0'
}, nls.localize('overviewRulerBracketMatchForeground', 'Overview ruler marker color for matching brackets.'));

var JumpToBracketAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(JumpToBracketAction, _EditorAction);

  var _super = _createSuper(JumpToBracketAction);

  function JumpToBracketAction() {
    _classCallCheck(this, JumpToBracketAction);

    return _super.call(this, {
      id: 'editor.action.jumpToBracket',
      label: nls.localize('smartSelect.jumpBracket', "Go to Bracket"),
      alias: 'Go to Bracket',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: 2048
        /* CtrlCmd */
        | 1024
        /* Shift */
        | 88
        /* US_BACKSLASH */
        ,
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(JumpToBracketAction, [{
    key: "run",
    value: function run(accessor, editor) {
      var controller = BracketMatchingController.get(editor);

      if (!controller) {
        return;
      }

      controller.jumpToBracket();
    }
  }]);

  return JumpToBracketAction;
}(EditorAction);

var SelectToBracketAction = /*#__PURE__*/function (_EditorAction2) {
  _inherits(SelectToBracketAction, _EditorAction2);

  var _super2 = _createSuper(SelectToBracketAction);

  function SelectToBracketAction() {
    _classCallCheck(this, SelectToBracketAction);

    return _super2.call(this, {
      id: 'editor.action.selectToBracket',
      label: nls.localize('smartSelect.selectToBracket', "Select to Bracket"),
      alias: 'Select to Bracket',
      precondition: undefined,
      description: {
        description: "Select to Bracket",
        args: [{
          name: 'args',
          schema: {
            type: 'object',
            properties: {
              'selectBrackets': {
                type: 'boolean',
                default: true
              }
            }
          }
        }]
      }
    });
  }

  _createClass(SelectToBracketAction, [{
    key: "run",
    value: function run(accessor, editor, args) {
      var controller = BracketMatchingController.get(editor);

      if (!controller) {
        return;
      }

      var selectBrackets = true;

      if (args && args.selectBrackets === false) {
        selectBrackets = false;
      }

      controller.selectToBracket(selectBrackets);
    }
  }]);

  return SelectToBracketAction;
}(EditorAction);

var BracketsData = function BracketsData(position, brackets, options) {
  _classCallCheck(this, BracketsData);

  this.position = position;
  this.brackets = brackets;
  this.options = options;
};

export var BracketMatchingController = /*#__PURE__*/function (_Disposable) {
  _inherits(BracketMatchingController, _Disposable);

  var _super3 = _createSuper(BracketMatchingController);

  function BracketMatchingController(editor) {
    var _this;

    _classCallCheck(this, BracketMatchingController);

    _this = _super3.call(this);
    _this._editor = editor;
    _this._lastBracketsData = [];
    _this._lastVersionId = 0;
    _this._decorations = [];
    _this._updateBracketsSoon = _this._register(new RunOnceScheduler(function () {
      return _this._updateBrackets();
    }, 50));
    _this._matchBrackets = _this._editor.getOption(55
    /* matchBrackets */
    );

    _this._updateBracketsSoon.schedule();

    _this._register(editor.onDidChangeCursorPosition(function (e) {
      if (_this._matchBrackets === 'never') {
        // Early exit if nothing needs to be done!
        // Leave some form of early exit check here if you wish to continue being a cursor position change listener ;)
        return;
      }

      _this._updateBracketsSoon.schedule();
    }));

    _this._register(editor.onDidChangeModelContent(function (e) {
      _this._updateBracketsSoon.schedule();
    }));

    _this._register(editor.onDidChangeModel(function (e) {
      _this._lastBracketsData = [];
      _this._decorations = [];

      _this._updateBracketsSoon.schedule();
    }));

    _this._register(editor.onDidChangeModelLanguageConfiguration(function (e) {
      _this._lastBracketsData = [];

      _this._updateBracketsSoon.schedule();
    }));

    _this._register(editor.onDidChangeConfiguration(function (e) {
      if (e.hasChanged(55
      /* matchBrackets */
      )) {
        _this._matchBrackets = _this._editor.getOption(55
        /* matchBrackets */
        );
        _this._decorations = _this._editor.deltaDecorations(_this._decorations, []);
        _this._lastBracketsData = [];
        _this._lastVersionId = 0;

        _this._updateBracketsSoon.schedule();
      }
    }));

    return _this;
  }

  _createClass(BracketMatchingController, [{
    key: "jumpToBracket",
    value: function jumpToBracket() {
      if (!this._editor.hasModel()) {
        return;
      }

      var model = this._editor.getModel();

      var newSelections = this._editor.getSelections().map(function (selection) {
        var position = selection.getStartPosition(); // find matching brackets if position is on a bracket

        var brackets = model.matchBracket(position);
        var newCursorPosition = null;

        if (brackets) {
          if (brackets[0].containsPosition(position)) {
            newCursorPosition = brackets[1].getStartPosition();
          } else if (brackets[1].containsPosition(position)) {
            newCursorPosition = brackets[0].getStartPosition();
          }
        } else {
          // find the enclosing brackets if the position isn't on a matching bracket
          var enclosingBrackets = model.findEnclosingBrackets(position);

          if (enclosingBrackets) {
            newCursorPosition = enclosingBrackets[0].getStartPosition();
          } else {
            // no enclosing brackets, try the very first next bracket
            var nextBracket = model.findNextBracket(position);

            if (nextBracket && nextBracket.range) {
              newCursorPosition = nextBracket.range.getStartPosition();
            }
          }
        }

        if (newCursorPosition) {
          return new Selection(newCursorPosition.lineNumber, newCursorPosition.column, newCursorPosition.lineNumber, newCursorPosition.column);
        }

        return new Selection(position.lineNumber, position.column, position.lineNumber, position.column);
      });

      this._editor.setSelections(newSelections);

      this._editor.revealRange(newSelections[0]);
    }
  }, {
    key: "selectToBracket",
    value: function selectToBracket(selectBrackets) {
      if (!this._editor.hasModel()) {
        return;
      }

      var model = this._editor.getModel();

      var newSelections = [];

      this._editor.getSelections().forEach(function (selection) {
        var position = selection.getStartPosition();
        var brackets = model.matchBracket(position);

        if (!brackets) {
          brackets = model.findEnclosingBrackets(position);

          if (!brackets) {
            var nextBracket = model.findNextBracket(position);

            if (nextBracket && nextBracket.range) {
              brackets = model.matchBracket(nextBracket.range.getStartPosition());
            }
          }
        }

        var selectFrom = null;
        var selectTo = null;

        if (brackets) {
          brackets.sort(Range.compareRangesUsingStarts);

          var _brackets = brackets,
              _brackets2 = _slicedToArray(_brackets, 2),
              open = _brackets2[0],
              close = _brackets2[1];

          selectFrom = selectBrackets ? open.getStartPosition() : open.getEndPosition();
          selectTo = selectBrackets ? close.getEndPosition() : close.getStartPosition();
        }

        if (selectFrom && selectTo) {
          newSelections.push(new Selection(selectFrom.lineNumber, selectFrom.column, selectTo.lineNumber, selectTo.column));
        }
      });

      if (newSelections.length > 0) {
        this._editor.setSelections(newSelections);

        this._editor.revealRange(newSelections[0]);
      }
    }
  }, {
    key: "_updateBrackets",
    value: function _updateBrackets() {
      if (this._matchBrackets === 'never') {
        return;
      }

      this._recomputeBrackets();

      var newDecorations = [],
          newDecorationsLen = 0;

      var _iterator = _createForOfIteratorHelper(this._lastBracketsData),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var bracketData = _step.value;
          var brackets = bracketData.brackets;

          if (brackets) {
            newDecorations[newDecorationsLen++] = {
              range: brackets[0],
              options: bracketData.options
            };
            newDecorations[newDecorationsLen++] = {
              range: brackets[1],
              options: bracketData.options
            };
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._decorations = this._editor.deltaDecorations(this._decorations, newDecorations);
    }
  }, {
    key: "_recomputeBrackets",
    value: function _recomputeBrackets() {
      if (!this._editor.hasModel()) {
        // no model => no brackets!
        this._lastBracketsData = [];
        this._lastVersionId = 0;
        return;
      }

      var selections = this._editor.getSelections();

      if (selections.length > 100) {
        // no bracket matching for high numbers of selections
        this._lastBracketsData = [];
        this._lastVersionId = 0;
        return;
      }

      var model = this._editor.getModel();

      var versionId = model.getVersionId();
      var previousData = [];

      if (this._lastVersionId === versionId) {
        // use the previous data only if the model is at the same version id
        previousData = this._lastBracketsData;
      }

      var positions = [],
          positionsLen = 0;

      for (var i = 0, len = selections.length; i < len; i++) {
        var selection = selections[i];

        if (selection.isEmpty()) {
          // will bracket match a cursor only if the selection is collapsed
          positions[positionsLen++] = selection.getStartPosition();
        }
      } // sort positions for `previousData` cache hits


      if (positions.length > 1) {
        positions.sort(Position.compare);
      }

      var newData = [],
          newDataLen = 0;
      var previousIndex = 0,
          previousLen = previousData.length;

      for (var _i = 0, _len = positions.length; _i < _len; _i++) {
        var position = positions[_i];

        while (previousIndex < previousLen && previousData[previousIndex].position.isBefore(position)) {
          previousIndex++;
        }

        if (previousIndex < previousLen && previousData[previousIndex].position.equals(position)) {
          newData[newDataLen++] = previousData[previousIndex];
        } else {
          var brackets = model.matchBracket(position);
          var options = BracketMatchingController._DECORATION_OPTIONS_WITH_OVERVIEW_RULER;

          if (!brackets && this._matchBrackets === 'always') {
            brackets = model.findEnclosingBrackets(position, 20
            /* give at most 20ms to compute */
            );
            options = BracketMatchingController._DECORATION_OPTIONS_WITHOUT_OVERVIEW_RULER;
          }

          newData[newDataLen++] = new BracketsData(position, brackets, options);
        }
      }

      this._lastBracketsData = newData;
      this._lastVersionId = versionId;
    }
  }], [{
    key: "get",
    value: function get(editor) {
      return editor.getContribution(BracketMatchingController.ID);
    }
  }]);

  return BracketMatchingController;
}(Disposable);
BracketMatchingController.ID = 'editor.contrib.bracketMatchingController';
BracketMatchingController._DECORATION_OPTIONS_WITH_OVERVIEW_RULER = ModelDecorationOptions.register({
  stickiness: 1
  /* NeverGrowsWhenTypingAtEdges */
  ,
  className: 'bracket-match',
  overviewRuler: {
    color: themeColorFromId(overviewRulerBracketMatchForeground),
    position: OverviewRulerLane.Center
  }
});
BracketMatchingController._DECORATION_OPTIONS_WITHOUT_OVERVIEW_RULER = ModelDecorationOptions.register({
  stickiness: 1
  /* NeverGrowsWhenTypingAtEdges */
  ,
  className: 'bracket-match'
});
registerEditorContribution(BracketMatchingController.ID, BracketMatchingController);
registerEditorAction(SelectToBracketAction);
registerEditorAction(JumpToBracketAction);
registerThemingParticipant(function (theme, collector) {
  var bracketMatchBackground = theme.getColor(editorBracketMatchBackground);

  if (bracketMatchBackground) {
    collector.addRule(".monaco-editor .bracket-match { background-color: ".concat(bracketMatchBackground, "; }"));
  }

  var bracketMatchBorder = theme.getColor(editorBracketMatchBorder);

  if (bracketMatchBorder) {
    collector.addRule(".monaco-editor .bracket-match { border: 1px solid ".concat(bracketMatchBorder, "; }"));
  }
}); // Go to menu

MenuRegistry.appendMenuItem(MenuId.MenubarGoMenu, {
  group: '5_infile_nav',
  command: {
    id: 'editor.action.jumpToBracket',
    title: nls.localize({
      key: 'miGoToBracket',
      comment: ['&& denotes a mnemonic']
    }, "Go to &&Bracket")
  },
  order: 2
});